import styled from 'styled-components';
import { BasePanel } from 'styles/components';
import { Colors } from 'styles/constants';
export { LinkButton, PlusIcon, Button } from 'styles/components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Panel = styled(BasePanel)`
  flex: 0 1 100%;
  flex-direction: column;
  background: ${Colors.White};
  padding: 24px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${Colors.Gray40};
  margin-bottom: 1rem;
`;

export const FilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${Colors.Gray40};
`;

export const IconsBox = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  padding: 3px;
`;
